var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { inject } from 'mobx-react';

import { languagesStore } from 'sdc-i18n-stores';
import { editingMode } from 'sdc-cms-writing';

import { ValueTextEdit } from './ValueTextEdit';

var EntryFieldsList = inject('controlsStore', 'typesStore')(function (_ref) {
  var controlsStore = _ref.controlsStore,
      typesStore = _ref.typesStore,
      type = _ref.type,
      fields = _ref.fields,
      children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['controlsStore', 'typesStore', 'type', 'fields', 'children', 'className', 'style']);

  if (!fields) {
    var key = 'tab.' + type;
    var modeFields = (controlsStore.valuesByKey[key + '.' + editingMode.mode] || {}).value;
    var allFields = (controlsStore.valuesByKey[key] || {}).value;
    fields = (modeFields || allFields || '').split(',');
  }
  return React.createElement(
    'div',
    { className: className, style: style },
    fields.map(function (field) {
      return typesStore.fields[field] || {};
    }).map(function (field, index) {
      return field.localize ? languagesStore.languagesAvailable.map(function (lang) {
        return React.createElement(ValueTextEdit, _extends({ key: (field.key || index) + ':' + lang, field: field.key, locale: languagesStore.languages[lang] }, props));
      }) : React.createElement(ValueTextEdit, _extends({ key: field.key || index, field: field.key }, props));
    }),
    children
  );
});
export { EntryFieldsList };